import { IFaq } from '@propertypal/shared/src/types/strapi';
import React from 'react';
import { Heading, SmallHeading } from '../typography';
import FaqList from './FaqList';
import FaqNotFound from './FaqNotFound';

interface FaqSectionContentProps {
  data: IFaq[] | null;
  subsection?: string | null;
  subSectionName: string;
  subSectionSubtitle: string | null;
  agent?: boolean;
}

const FaqSectionContent: React.FC<FaqSectionContentProps> = ({
  data,
  subSectionName,
  subSectionSubtitle,
  subsection,
  agent,
}) => {
  return (
    <div>
      {data && (
        <>
          <Heading data-testid="faq-heading">{subSectionName || 'FAQs'}</Heading>
          {subSectionSubtitle && (
            <SmallHeading mt={5} fontSize={16} fontWeight="normal" data-testid="faq-sub-heading">
              {subSectionSubtitle}
            </SmallHeading>
          )}
        </>
      )}
      {data && data.length ? (
        <FaqList faqs={data} link={`/faq/${agent ? 'agent-faq/' : ''}${subsection}`} />
      ) : (
        <FaqNotFound noArticles={!!data} />
      )}
    </div>
  );
};

export default FaqSectionContent;
